// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4743ae3e","952":"61a447cf"}[chunkId] + ".chunk.js";
};